import React from 'react';
import { Table, Form, Spinner } from 'react-bootstrap';

const DynamicEditableTable = ({ 
  columns = [], 
  data = [], 
  loading = false, 
  onCellChange 
}) => {

  const cellStyle = {
    padding: '2px 6px',
    fontSize: '13px',
    verticalAlign: 'middle',
  };

  const inputStyle = {
    padding: '2px 6px',
    fontSize: '13px',
    height: '28px',
    textAlign: 'center',
  };

  return (
    <>
      {loading ? (
        <div className='d-flex justify-content-center'>
          <Spinner animation="border" size="sm" role="status" className="me-2" />
          Loading...
        </div>
      ) : (
        <Table bordered size="sm" className="mb-0" style={{ tableLayout: 'fixed', width: '100%' }}>
          <thead>
            <tr className="text-center">
              {columns.map((col, idx) => (
                <th key={idx} style={{ ...cellStyle, width: col.width || 'auto' }}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex} className="text-center">
                {columns.map((col, colIndex) => (
                  <td key={colIndex} style={{ ...cellStyle, width: col.width || 'auto', textAlign: col.align || 'center' }}>
                    {col.editable ? (
                      <Form.Control
                        className="text-end"                        
                        type={col.type || 'text'}
                        size="sm"
                        style={inputStyle}
                        placeholder='0'
                        value={row[col.key] <=0 ? '' : row[col.key]}
                        onChange={(e) =>
                          onCellChange?.(row.id,e.target.value)
                        }
                      />
                    ) : (
                      row[col.key]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default DynamicEditableTable;
